import styled from 'styled-components';

interface IPredefinedOptionsStyled {
  resultHeaderWidth: number;
}

interface IPredefinedOption {
  backgroundIndex: number;
  selected: boolean;
}

export const Container = styled.div<IPredefinedOptionsStyled>`
  position: absolute;
  background: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  left: 490px;
  padding: 16px;
  overflow: hidden;
  // gap: 16px;
  width: ${({ resultHeaderWidth }) => `${resultHeaderWidth! - 240}px`};
`;

export const PredefinedOption = styled.div<IPredefinedOption>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 32px;
  z-index: 1;
  width: fit-content;
  height: fit-content;
  background: ${({ backgroundIndex, theme }) => theme.colors.pastelScale[backgroundIndex]};
  color: ${({ theme }) => theme.colors.gray[50]};
  border-radius: 16px;
  border: 4px solid ${({ theme, backgroundIndex, selected }) => selected ? theme.colors.primary.dark : theme.colors.pastelScale[backgroundIndex]};
  opacity: ${({ selected }) => selected ? 1 : 0.6 };

  h6 {
    font-size: 16px;
    font-weight: bold;
  }

  transition: all 0.6s ease-in-out;
  &:hover {
    opacity: 1;
    background: ${({ backgroundIndex, theme, }) => theme.colors.pastelScale[backgroundIndex] };
    color: ${({ theme }) => theme.colors.gray[50] };
    cursor: pointer;
  }

  > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 8px;

      > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 4px;

        img {
          width: 16px;
          padding: 0;
        }

        span {
          font-size: 11px;
        }
      }
    }
`;
